import React, { useState } from 'react';
import { MdModeEditOutline } from 'react-icons/md';
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import AdminEditBrand from './AdminEditBrand';

const AdminBrandCard = ({ data, fetchdata, serialNumber }) => {
  const [editBrand, setEditBrand] = useState(false);

  return (
    <div className='bg-white p-3 rounded-lg relative shadow-md hover:shadow-lg transition-all duration-200 w-64 min-h-[90px]'>

      {/* Status */}
      {parseInt(data.is_active) === 1 ? (
        <div className='absolute top-2 right-2'>
          <FaCheckCircle className='text-green-600 text-base' />
        </div>
      ) : (
        <div className='absolute top-2 right-2'>
          <FaTimesCircle className='text-red-600 text-base' />
        </div>
      )}

      <div className='w-full'>

        {/* Serial + Brand Name in same row */}
        <div className='flex justify-center items-center gap-2 mt-1'>

          <span className='text-xs text-gray-500 font-medium'>
            {serialNumber}.
          </span>

          <h1 className='font-bold text-lg text-gray-800'>
            {data.brand_name || 'Brand Name'}
          </h1>

        </div>

        {/* Edit Button */}
        <div className='flex justify-end mt-3'>
          <button
            className='p-2 bg-green-50 hover:bg-green-600 rounded-full hover:text-white transition-all'
            onClick={() => setEditBrand(true)}
          >
            <MdModeEditOutline size={15} />
          </button>
        </div>

      </div>

      {editBrand && (
        <AdminEditBrand
          brandData={data}
          onClose={() => setEditBrand(false)}
          fetchdata={fetchdata}
        />
      )}

    </div>
  );
};

export default AdminBrandCard;